import { render } from "./checkout_antecipado.vue?vue&type=template&id=e5804614"
import script from "./checkout_antecipado.vue?vue&type=script&lang=js"
export * from "./checkout_antecipado.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__